<template>
  <PageLayout>
    <template v-slot:header>
      <div class="d-flex m-3 mx-lg-0">
        <Breadcrumb :list="breadcrumbList" />
      </div>
      <MainNavbar />
    </template>
    <template v-slot:main>
      <b-card class="without-padding-bottom">
        <header slot="header">
          <b-row>
            <b-col lg="12">
              {{ labels.title }}
            </b-col>
          </b-row>
          <b-row class="pt-3 pb-3 audit-logs-filter">
            <b-col cols="12" xl="4">
              <b-form-group>
                <b-form-select
                  class="audit-logs-input"
                  :value="entity"
                  @input="changeEntity($event)"
                >
                  <option :value="null">
                    {{ labels.select }}
                  </option>
                  <option
                    v-for="entity in Object.keys(labels.entities).sort()"
                    :key="entity"
                    :value="entity"
                  >
                    {{ labels.entities[entity] }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.table.entity }}
                </label>
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="6">
              <b-form-group>
                <b-form-select
                  class="audit-logs-input"
                  :value="action"
                  @input="changeAction($event)"
                >
                  <option :value="null">
                    {{ labels.select }}
                  </option>
                  <option
                    v-for="action in Object.keys(labels.actions).sort()"
                    :key="action"
                    :value="action"
                  >
                    {{ labels.actions[action] }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.table.action }}
                </label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="audit-logs-filter">
            <b-col cols="12" xl="4">
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    autocomplete="off"
                    v-model="text"
                    class="text-form-group-btn"
                    v-on:keyup.13="loadAuditLogs"
                  />
                  <label class="custom-input-label">
                    {{ labels.group }}
                  </label>
                  <template v-slot:append>
                    <b-button
                      class="apply-form-group-btn"
                      variant="primary"
                      size="lg"
                      @click="loadAuditLogs"
                    >
                      <i class="material-icons">search</i>
                    </b-button>
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="text-gray03 pl-2 pt-3">
              <h6 v-if="!loading">
                {{ labels.subtitle | parse({ COUNT: auditLogsSize }) }}
              </h6>
            </b-col>
          </b-row>
        </header>

        <div v-if="loading" class="loading">
          <loading />
          <p>{{ labels.loading }}</p>
        </div>

        <div class="full-table-wraper" v-else>
          <b-table
            responsive
            striped
            :fields="fields"
            :items="auditLogs"
            class="table-responsive"
          >
            <template v-slot:cell(request)="data">
              <div class="flexbox entity">
                <i
                  class="material-icons mt-2 text-primary h3"
                  @click="showDetail(data.item)"
                >
                  description
                </i>
              </div>
            </template>

            <template v-slot:cell(createdAt)="data">
              <div class="flexbox entity">
                <div class="p-2 table-font-size text-center">
                  <small>
                    {{ $moment(data.item.createdAt).format('HH:mm:ss') }}
                  </small>
                  <br />
                  <small>
                    {{ $moment(data.item.createdAt).format('DD/MM/YYYY') }}
                  </small>
                </div>
              </div>
            </template>

            <template v-slot:cell(actor)="data">
              <b-row class="padding-row">
                <b-col class="float-right ellipsis-text p-2">
                  <b-row class="table-font-size">
                    <b-col lg="12" class="ellipsis-text user-status">
                      <span class="medium fullname">
                        {{ data.item.actor.name }}
                      </span>
                    </b-col>
                    <b-col lg="12" class="ellipsis-text">
                      <small>{{ data.item.actor.email }}</small>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>

            <template v-slot:cell(entity)="data">
              <div class="flexbox entity">
                <div class="pt-3 table-font-size">
                  <span class="medium">
                    {{ labels.entities[data.item.entity] }}
                  </span>
                </div>
              </div>
            </template>

            <template v-slot:cell(action)="data">
              <div class="flexbox">
                <div class="p-2 table-font-size">
                  <small>
                    {{ labels.actions[data.item.action] }}
                    <span
                      v-if="data.item.entity === 'groups' && data.item.object"
                      class="action-description"
                    >
                      {{ data.item.object.name }}
                    </span>
                    <span
                      v-if="data.item.entity === 'users' && data.item.object"
                      class="action-description"
                    >
                      {{
                        [
                          'users.edit.self',
                          'users.invite',
                          'users.export',
                        ].includes(data.item.action)
                          ? ''
                          : `${data.item.object.profile.firstname} ${data.item.object.profile.lastname}`
                      }}
                    </span>
                  </small>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>

      <b-modal ref="log-detail" :title="getTitle(selectedLog)" hide-footer>
        <p>
          <span class="text-primary">
            {{ selectedLog.actor.name }}
          </span>
          <small class="float-right">
            {{ `${selectedLog.actor.email}` }}
          </small>
        </p>

        <p class="text-primary quote">
          {{ labels.actions[selectedLog.action] }}
          <span
            v-if="selectedLog.entity === 'groups' && selectedLog.object"
            class="action-description-detail"
          >
            {{ selectedLog.object.name }}
          </span>
          <span
            v-if="selectedLog.entity === 'users' && selectedLog.object"
            class="action-description-detail"
          >
            {{
              ['users.edit.self', 'users.invite', 'users.export'].includes(
                selectedLog.action
              )
                ? ''
                : `${selectedLog.object.profile.firstname} ${selectedLog.object.profile.lastname}`
            }}
          </span>
        </p>

        <hr />

        <div class="log-body text-primary">
          <small v-if="selectedLog.path">
            [{{ selectedLog.method }}] {{ selectedLog.path.split('v1')[1] }}
          </small>

          <b-card class="mt-3 body-card" v-if="hasBody(selectedLog.body)">
            <pre class="m-0">{{ stringify(selectedLog.body) }}</pre>
          </b-card>

          <hr class="mt-4" />

          <small class="float-left">
            {{ selectedLog.actor.user_agent }}
          </small>

          <small class="float-right">
            {{ selectedLog.actor.forwarded_for }}
          </small>
        </div>
      </b-modal>

      <div class="mb-4 overflow-auto">
        <div class="mt-3" v-if="!loading">
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="numberOfPages"
            align="center"
            use-router
            v-model="page"
          >
          </b-pagination-nav>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import PageLayout from '@/components/Home/PageLayout.vue'
import Loading from '@/components/Shared/Loading.vue'
import MainNavbar from '@/components/Management/MainNavbar'

export default {
  components: {
    Breadcrumb,
    PageLayout,
    Loading,
    MainNavbar,
  },

  data() {
    return {
      selectedLog: { actor: {} },
      page: 1,
      limit: 10,
      offset: 0,
      entity: null,
      action: null,
      text: null,
    }
  },

  created() {
    this.loadAuditLogs()
  },

  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'audit-logs' })
  },

  watch: {
    page() {
      this.offset = (this.page - 1) * this.limit
      this.loadAuditLogs()
    },
  },

  computed: {
    breadcrumbList() {
      return [
        {
          label: this.resources.general.menu.settings,
        },
      ]
    },

    fields: function() {
      return [
        {
          key: 'createdAt',
          label: this.labels.table.createdAt,
        },
        {
          key: 'actor',
          label: this.labels.table.actor,
        },
        {
          key: 'entity',
          label: this.labels.table.entity,
        },
        {
          key: 'action',
          label: this.labels.table.action,
          class: 'action-col',
        },
        {
          key: 'request',
          label: '',
        },
      ]
    },

    ...mapGetters({
      resources: 'resources',
      loading: 'auditLogs/loading',
      auditLogs: 'auditLogs/auditLogs',
      auditLogsSize: 'auditLogs/total',
    }),

    labels() {
      return this.resources.page.home.auditLogs
    },

    numberOfPages() {
      const numberOfPages = this.auditLogsSize / this.limit
      if (Number.isInteger(numberOfPages)) {
        return numberOfPages
      }
      return parseInt(numberOfPages) + 1
    },
  },

  methods: {
    getTitle({ entity, createdAt }) {
      const datetime = this.$moment(createdAt).format('HH:mm:ss - DD/MM/YYYY')
      return `${this.labels.entities[entity]} | ${datetime}`
    },

    hasBody(body) {
      return body && Object.keys(body).length > 0 ? true : false
    },

    stringify(obj) {
      return obj ? JSON.stringify(obj, null, 2) : ''
    },

    showDetail(log) {
      this.selectedLog = log
      this.$refs['log-detail'].show()
    },

    loadAuditLogs() {
      this.$store.dispatch('auditLogs/loadAuditLogs', {
        offset: this.offset,
        limit: this.limit,
        entity: this.entity,
        action: this.action,
        text: this.text,
      })
    },

    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },

    async changeEntity(entity) {
      this.entity = entity
      this.loadAuditLogs()
    },

    async changeAction(action) {
      this.action = action
      this.loadAuditLogs()
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.loading {
  text-align: center;
  width: 100%;
  margin-top: 10%;
  margin-bottom: 10%;
  margin-left: 0.9px;
  margin-right: 0.9px;
}

.without-padding-bottom {
  margin-bottom: 20px;
}

.card-header {
  padding-right: 15px;
}

.header-text {
  font-size: 12px;
}

table-striped tbody tr:nth-of-type(odd) {
  background-color: #f6f7fd !important;
}

.flexbox {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.entity {
    justify-content: center;
  }
}

.table-font-size {
  font-size: 14px;
}

.padding-row {
  .row {
    display: block !important;
  }
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;

  &.min-width {
    width: 10px;
  }
}

.full-table-wraper {
  margin-left: -20px;
  margin-right: -20px;

  /deep/ .b-table {
    thead {
      text-align: center;

      th {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
    td {
      &.action-col {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
  }
}

.action-description {
  font-size: 0.7rem;
  font-weight: bold;
}

.action-description-detail {
  font-size: 1.1rem;
  font-weight: bold;
}

.body-card {
  width: 100%;
}

.quote {
  margin: 0;
  background: #eee;
  padding: 1em;
  border-radius: 1em;
}

.card-header {
  font-size: 24px;
}

.audit-logs-filter {
  .audit-logs-input {
    border-radius: 10px !important;
    background-color: map-get($theme-colors, 'white') !important;
    border-color: var(--gray07) !important;
    cursor: pointer;
  }

  .text-form-group-btn {
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    background-color: map-get($theme-colors, 'white') !important;
    border-color: var(--gray07) !important;
    height: 45px !important;
  }

  .apply-form-group-btn {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    height: 45px !important;
  }
}
</style>
